import type { RecordResponse } from '@/models/ServiceTypes';
import type { DashboardWidget } from './dashboardApi';

const ADVISOR_UNFINISHED_WIDGET_CODES = ['advisor-accounts-grid'];

// This advisor code resolves to the Clients widget that dashboardAdvisorView
// pins to the left column. Keep the widget mapping available, but do not let
// the loader place it a second time or users move it through customization.
const ADVISOR_PINNED_CLIENTS_WIDGET_CODES = ['advisor-clients-grid'];

const ADVISOR_HIDDEN_WIDGET_CODES = new Set([
  ...ADVISOR_UNFINISHED_WIDGET_CODES,
  ...ADVISOR_PINNED_CLIENTS_WIDGET_CODES,
]);

// These investor codes resolve to the hard-coded Balance Sheet dashboard widget.
// Keep the external widget mappings available, but do not let users add them
// through dashboard customization.
const INVESTOR_NON_CUSTOMIZABLE_BALANCE_SHEET_WIDGET_CODES = new Set([
  'investor-account-list',
  'investor-balancesheet-chart',
  'investor-balancesheet-grid',
]);

const getHiddenWidgetCodesForRole = (role?: string | null) => {
  switch ((role ?? '').toLowerCase()) {
    case 'advisor':
      return ADVISOR_HIDDEN_WIDGET_CODES;
    case 'investor':
      return INVESTOR_NON_CUSTOMIZABLE_BALANCE_SHEET_WIDGET_CODES;
    default:
      return null;
  }
};

export const filterDashboardWidgetsForRole = (
  data: RecordResponse<DashboardWidget>,
  role?: string | null,
): RecordResponse<DashboardWidget> => {
  const hiddenWidgetCodes = getHiddenWidgetCodesForRole(role);

  if (!hiddenWidgetCodes || !Array.isArray(data.Records)) {
    return data;
  }

  const filteredRecords = data.Records.filter(
    (widget) => !hiddenWidgetCodes.has(widget.Code),
  );

  if (filteredRecords.length === data.Records.length) {
    return data;
  }

  return {
    ...data,
    Records: filteredRecords,
    TotalLength: filteredRecords.length,
  };
};
